import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import { FieldProps } from '@rjsf/utils'
import { useTranslation } from 'react-i18next'
import { dashify } from 'utils/dashify'

export const CheckboxField = (props: FieldProps) => {
  const { idSchema, registry, schema, formData, uiSchema, ...rest } = props
  const { t } = useTranslation()

  const label =
    uiSchema['ui:title'] ||
    uiSchema['ui:label'] ||
    uiSchema['ui:title-translation-key']

  const translatedLabel = label
    ? t(`project:ws-${dashify(label)}`, { defaultValue: label, ns: 'project' })
    : ''

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            {...rest}
            size="small"
            checked={Boolean(formData)}
            color="secondary"
            onBlur={(e) => props.onBlur(props.id, e.target)}
            onFocus={(e) => props.onFocus(props.id, e.target)}
            onChange={(e, checked) => {
              rest.onChange(checked)
            }}
          />
        }
        labelPlacement="top"
        label={<Typography variant="body2">{translatedLabel}</Typography>}
      />
    </>
  )
}
